<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="owners">
      <div class="row">
        @for (owner of owners.controls; track owner; let index = $index) {
          <ng-container [formGroup]="owner">
            <div class="col-md-{{ owners?.length > 1 ? 6 : 12 }}">
              <owner-header [owners]="owners" [index]="index"></owner-header>
              <div>
                <pr-input-radio
                  formControlName="userMajeurCapable"
                  columns="3"
                  [toggle]="true"
                  [isDefault]="false"
                  label="Êtes-vous majeur sans mesure de protection ?"
                >
                </pr-input-radio>
                <div class="row">
                  <div
                    class="col-md-6 p-0"
                    [ngClass]="{ 'w-100': owners.length > 1 }"
                  >
                    <pr-input-column
                      label="Pays de naissance"
                      [derrors]="derrors"
                    >
                      <pr-select-search
                        formControlName="userBirthCountry"
                        label="Pays de naissance"
                        [options]="countries"
                      >
                      </pr-select-search>
                    </pr-input-column>
                  </div>
                  <div
                    class="col-md-6 p-0"
                    [ngClass]="{ 'w-100': owners.length > 1 }"
                  >
                    <pr-input-column label="Nationalité" [derrors]="derrors">
                      <pr-select-search
                        formControlName="userNationality"
                        label="Nationalité"
                        [options]="countries"
                      >
                      </pr-select-search>
                    </pr-input-column>
                  </div>
                </div>
                <div class="row">
                  <div
                    class="col-md-6 p-0"
                    [ngClass]="{ 'w-100': owners.length > 1 }"
                  >
                    <user-other-nationalities
                      formArrayName="userOtherNationalities"
                      [derrors]="derrors"
                    >
                    </user-other-nationalities>
                  </div>
                </div>
                <div class="row">
                  <div
                    class="col-md-6 p-0"
                    [ngClass]="{ 'w-100': owners.length > 1 }"
                  >
                    <pr-input-column label="Code postal" [derrors]="derrors">
                      <input
                        formControlName="userBirthZipCode"
                        type="text"
                        [showMaskTyped]="true"
                      />
                    </pr-input-column>
                  </div>
                  @if (
                    !isSwisslifeProduct ||
                    !countries?.length ||
                    isOwnerBirthCountryNotFR(owner)
                  ) {
                    <div
                      class="col-md-6 p-0"
                      [ngClass]="{ 'w-100': owners.length > 1 }"
                    >
                      <pr-input-column
                        label="Ville de naissance"
                        [derrors]="derrors"
                      >
                        <input formControlName="userBirthCity" type="text" />
                      </pr-input-column>
                    </div>
                  }
                  @if (
                    isSwisslifeProduct &&
                    countries?.length &&
                    !isOwnerBirthCountryNotFR(owner)
                  ) {
                    <div
                      class="col-md-6 p-0"
                      [ngClass]="{ 'w-100': owners.length > 1 }"
                    >
                      <pr-input-column
                        label="Ville de naissance"
                        [derrors]="derrors"
                      >
                        <pr-select-search
                          formControlName="userBirthCity"
                          label="Ville de naissance"
                          [options]="filteredCities(owner)"
                          optionValueKey="city"
                          optionDisplayKey="city"
                        >
                        </pr-select-search>
                      </pr-input-column>
                      <pr-city-finder
                        [cities]="cities"
                        (citySelected)="onBirthCitySelected(owner, $event)"
                      ></pr-city-finder>
                    </div>
                  }
                  <div class="col-md-12 p-0" style="width: calc(100% - 27px)">
                    <pr-input-date
                      label="Votre date de naissance"
                      formControlName="userBirthDate"
                      [derrors]="derrors"
                      [isDefault]="false"
                    ></pr-input-date>
                  </div>
                  <div class="col-md-12 p-0">
                    <pr-input-column
                      label="Département de naissance"
                      [derrors]="derrors"
                    >
                      <pr-select-search
                        formControlName="userBirthLocation"
                        label="Département de naissance"
                        [options]="departments"
                      >
                      </pr-select-search>
                    </pr-input-column>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        }
      </div>
    </ng-container>
  </form-wrapper>
  <form-footer
    (prev)="prev()"
    (next)="onSubmit()"
    [disabledSkip]="true"
  ></form-footer>
</form>
<!-- <voice-recognition *ngIf="commands" [commands]="commands"></voice-recognition> -->

<!-- <form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
<owners-form [withOwnerArray]="true">
  <ng-template #ownerTemplate let-owner let-index="index">
    <ng-container [formGroup]="owner">
      <div *ngIf="reference$ | async as reference">
        <pr-input-radio
          formControlName="userMajeurCapable"
          columns="3"
          [toggle]="true"
          [isDefault]="false"
          label="Êtes-vous majeur sans mesure de protection ?"
          >
        </pr-input-radio>
        <div class="row">
          <div
            class="col-md-6 p-0"
            [ngClass]="{ 'w-100': owners.length > 1 }"
            >
            <pr-input-column label="Ville de naissance" [derrors]="derrors">
              <input formControlName="userBirthCity" type="text" />
            </pr-input-column>
          </div>
          <div
            class="col-md-6 p-0"
            [ngClass]="{ 'w-100': owners.length > 1 }"
            >
            <pr-input-column label="Code postal" [derrors]="derrors">
              <input
                formControlName="userBirthZipCode"
                type="text"
                [showMaskTyped]="true"
                />
            </pr-input-column>
          </div>

          <div class="col-md-12 p-0" style="width: calc(100% - 27px)">
            <pr-input-date
              label="Votre date de naissance"
              formControlName="userBirthDate"
              [derrors]="derrors"
              [isDefault]="false"
            ></pr-input-date>
          </div>
        </div>

        <div class="row">
          <div
            class="col-md-6 p-0"
            [ngClass]="{ 'w-100': owners.length > 1 }"
            >
            <pr-input-column label="Pays de naissance" [derrors]="derrors">
              <mat-select #select formControlName="userBirthCountry">
                <mat-option
                  *ngFor="let country of reference.countries"
                  [value]="country.id"
                  >
                  {{ country.value }}
                </mat-option>
              </mat-select>
            </pr-input-column>
          </div>
          <div
            class="col-md-6 p-0"
            [ngClass]="{ 'w-100': owners.length > 1 }"
            >
            <pr-input-column label="Nationalité" [derrors]="derrors">
              <mat-select formControlName="userNationality">
                <mat-option
                  *ngFor="let country of reference.countries"
                  [value]="country.id"
                  >
                  {{ country.value }}
                </mat-option>
              </mat-select>
            </pr-input-column>
          </div>
        </div>
        <div class="row">
          <div
            class="col-md-6 p-0"
            [ngClass]="{ 'w-100': owners.length > 1 }"
            >
            <user-other-nationalities
              formArrayName="userOtherNationalities"
              [derrors]="derrors"
              >
            </user-other-nationalities>
          </div>
        </div>
      </div>
    </ng-container>
  </ng-template>
</owners-form>
<form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form> -->

<!-- <form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
<div class="vh">
  <owner-form-array formArrayName="owners">
    <ng-template #ownerTemplate let-owner let-index="index">
      <ng-container [formGroup]="owner">
        <div *ngIf="reference$ | async as reference">
          <pr-input-radio
            formControlName="userMajeurCapable"
            columns="3"
            [toggle]="true"
            [isDefault]="false"
            label="Êtes-vous majeur sans mesure de protection ?"
            >
          </pr-input-radio>
          <div class="row">
            <div
              class="col-md-6 p-0"
              [ngClass]="{ 'w-100': owners.length > 1 }"
              >
              <pr-input-column label="Ville de naissance" [derrors]="derrors">
                <input formControlName="userBirthCity" type="text" />
              </pr-input-column>
            </div>
            <div
              class="col-md-6 p-0"
              [ngClass]="{ 'w-100': owners.length > 1 }"
              >
              <pr-input-column label="Code postal" [derrors]="derrors">
                <input
                  formControlName="userBirthZipCode"
                  type="text"
                  [showMaskTyped]="true"
                  />
              </pr-input-column>
            </div>

            <div class="col-md-12 p-0" style="width: calc(100% - 27px)">
              <pr-input-date
                label="Votre date de naissance"
                formControlName="userBirthDate"
                [derrors]="derrors"
                [isDefault]="false"
              ></pr-input-date>
            </div>
          </div>

          <div class="row">
            <div
              class="col-md-6 p-0"
              [ngClass]="{ 'w-100': owners.length > 1 }"
              >
              <pr-input-column label="Pays de naissance" [derrors]="derrors">
                <mat-select #select formControlName="userBirthCountry">
                  <mat-option
                    *ngFor="let country of reference.countries"
                    [value]="country.id"
                    >
                    {{ country.value }}
                  </mat-option>
                </mat-select>
              </pr-input-column>
            </div>
            <div
              class="col-md-6 p-0"
              [ngClass]="{ 'w-100': owners.length > 1 }"
              >
              <pr-input-column label="Nationalité" [derrors]="derrors">
                <mat-select formControlName="userNationality">
                  <mat-option
                    *ngFor="let country of reference.countries"
                    [value]="country.id"
                    >
                    {{ country.value }}
                  </mat-option>
                </mat-select>
              </pr-input-column>
            </div>
          </div>
          <div class="row">
            <div
              class="col-md-6 p-0"
              [ngClass]="{ 'w-100': owners.length > 1 }"
              >
              <user-other-nationalities
                formArrayName="userOtherNationalities"
                [derrors]="derrors"
                >
              </user-other-nationalities>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-template>
  </owner-form-array>
</div>
<form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form> -->
